export default {
  group: 'block',
  content: 'inline*',
  attrs: {},
  toDOM: () => ['p', 0],
  parseDOM: [{ tag: 'p' }],
};
